declare global {
  interface Window {
    ga?: {
      getAll?: () => { get: (value: string) => string }[];
    };
  }
}

export const getGoogleAnalyticsClientId = (): string | undefined => {
  let googleAnalyticsClientId: string | undefined;

  if (window?.ga?.getAll && typeof window.ga.getAll === 'function') {
    const [tracker] = window.ga.getAll();
    if (tracker && typeof tracker.get === 'function') {
      googleAnalyticsClientId = tracker.get('clientId');
    }
  }

  return googleAnalyticsClientId;
};
